import { ApiError } from "@/lib/http";

interface ErrorStateProps {
  title?: string;
  message?: string;
  error?: unknown;
  onRetry?: () => void;
  /**
   * Texto do botao. "Tentar de novo" descreve mal uma acao que nao repete
   * nada — recuperar um setor que falta, por exemplo, e criacao, e o operador
   * precisa saber disso ANTES de clicar.
   */
  retryLabel?: string;
}

function describeError(error: unknown): { title: string; message: string } {
  if (error instanceof ApiError) {
    if (error.isNotFound) {
      return {
        title: "Nao encontrado",
        message: "O recurso solicitado nao existe ou foi removido.",
      };
    }
    if (error.isNetwork) {
      return {
        title: "Sem conexao com a API",
        message: "Nao foi possivel alcancar o backend. Verifique se o servidor esta rodando.",
      };
    }
    return {
      title: `Erro HTTP ${error.status}`,
      message: error.message,
    };
  }
  if (error instanceof Error) {
    return { title: "Erro inesperado", message: error.message };
  }
  return { title: "Erro inesperado", message: "Algo deu errado." };
}

export function ErrorState({ title, message, error, onRetry, retryLabel }: ErrorStateProps) {
  const described = error ? describeError(error) : null;
  const finalTitle = title ?? described?.title ?? "Erro";
  const finalMessage = message ?? described?.message ?? "";

  return (
    <div className="state state--error" role="alert">
      <h2 className="state__title">{finalTitle}</h2>
      {finalMessage ? <p className="state__message">{finalMessage}</p> : null}
      {onRetry ? (
        <div className="state__actions">
          <button type="button" className="btn" onClick={onRetry}>
            {retryLabel ?? "Tentar de novo"}
          </button>
        </div>
      ) : null}
    </div>
  );
}
